<div class="page-header" [class.full-width-actions]="fullWidthActionsOnMobile">
  <div class="page-header-left">
    <h2 class="page-title">{{ title | translate: titleParams }}</h2>
    <p class="page-subtitle" *ngIf="subtitle">{{ subtitle | translate: subtitleParams }}</p>
  </div>
  <div class="page-header-actions">
    <ng-content select="[page-header-actions]"></ng-content>
  </div>
</div>
